export const foldedListItemsCount = 10;
export const nextPageItemsCount = 10;
